/* eslint-disable react/jsx-props-no-spreading */
import {
    useMemo,
} from 'react'

import useLabel from 'app/hooks/useLabel'
import getUniqueId from 'app/utils/getUniqueId'
import SimpleTable from 'app/shared-components/SimpleTable'
import {
    Fee,
} from 'app/Apps/Pricing/Pricing.types'
import {
    ProductTypeContainerTempRange,
} from 'app/Apps/OrderManagement/Orders/orders.types'

import FeeInputs from './FeeInputs'

type Props = {
    value?: Fee[],
    onChange: (value: Fee) => void,
    addEntry: () => void,
    deleteEntry: (index: number) => void,
    disabled?: boolean,
    currency?: string,
    name?: string,
    tempRange?: string,
    productTypes?: ProductTypeContainerTempRange[],
    feeValueLabel: string,
}

const defaultProps: Partial<Props> = {
    value: [],
    disabled: false,
    currency: undefined,
    name: undefined,
    tempRange: undefined,
    productTypes: [],
}

const Fees = ({
    value,
    onChange,
    addEntry,
    disabled,
    deleteEntry,
    currency: selectedCurrency,
    name,
    tempRange,
    productTypes,
}: Props) => {
    const l = useLabel()

    const defaultColumns = useMemo(() => {
        return [
            {
                label: l('Fee.feeName'),
                id: getUniqueId(),
            },
            {
                label: l('Fee.feeChargeability'),
                id: getUniqueId(),
            },
            {
                label: l('Fee.productType'),
                id: getUniqueId(),
            },
            {
                label: l('Fee.feeDescription'),
                id: getUniqueId(),
            },
            {
                label: selectedCurrency || l('Fee.feeValue'),
                id: getUniqueId(),
            },
        ]
    }, [
        l,
        selectedCurrency,
    ])

    return (
        <SimpleTable
            columns={defaultColumns}
            data={value}
            addEntry={addEntry}
            onChange={onChange}
            onDelete={deleteEntry}
            disabled={disabled}
            component={FeeInputs}
            renderComponent={(tableProps) => {
                return (
                    <FeeInputs
                        {...tableProps}
                        currency={selectedCurrency}
                        feeName={name}
                        productTypes={productTypes}
                        tempRange={tempRange}
                    />
                )
            }}
        />
    )
}

Fees.defaultProps = defaultProps

export default Fees
